import React from "react";
import PropTypes from "prop-types";
import ProfileCardWhite from "../icons/profile-card-white.svg";
import ProfileCardGrey from "../icons/profile-card-grey.svg";

const ReviewDetailStepIcon = ({ show, completed }) => {
  const iconSrc = show || completed ? ProfileCardWhite : ProfileCardGrey;

  return (
    <div className="stepLeft">
      <img
        src={iconSrc}
        alt="Review Step Icon"
        // style={{ height: 24, width: 24 }}
      />
    </div>
  );
};



ReviewDetailStepIcon.propTypes = {
  completed: PropTypes.any,
  show: PropTypes.bool,
};

export default ReviewDetailStepIcon;
